import { createFileRoute } from "@tanstack/react-router";
import { SubServicePage } from "@/components/SubServicePage";
import { SEO_SITE, hreflangLinks, ctaDesc, ctaTitle } from "@/lib/seo";

const meta = {"th":{"h1":"ภาษีเงินได้บุคคลธรรมดา (PIT) — ยื่น ภ.ง.ด.90/91/94","metaTitle":"ภาษีบุคคลธรรมดาไทย ภ.ง.ด.90/91/94 ต่างชาติ | NYC","metaDesc":"ยื่นภาษีเงินได้บุคคลไทย ภ.ง.ด.90/91/94 พร้อมสิทธิลดหย่อน LTF/RMF/SSF/ประกันชีวิต DTA 61 ประเทศ — เริ่มต้นง่าย ๆ แค่ทักไลน์ เราดูแลจนจบทุกขั้นตอน"},"en":{"h1":"Thai Personal Income Tax (PIT) — Filing PND.90/91/94","metaTitle":"Thai Personal Income Tax — Expats, DTA 61 countries | NYC","metaDesc":"Thai PIT filing PND.90/91/94 with LTF/RMF/SSF/insurance deductions and DTA relief across 61 countries. . — Start with a free review before you file anything."}} as const;

export const Route = createFileRoute("/tax/personal-pit")({
  head: () => {
    const url = `${SEO_SITE}/tax.personal-pit`;
    const c = meta.th;
    return {
      meta: [
        { title: ctaTitle(c.metaTitle, "/tax/personal-pit", "th")},
        { name: "description", content: ctaDesc(c.metaDesc, "/tax/personal-pit", "th")},
        { property: "og:title", content: ctaTitle(c.metaTitle, "/tax/personal-pit", "th")},
        { property: "og:description", content: ctaDesc(c.metaDesc, "/tax/personal-pit", "th")},
        { property: "og:url", content: url },
        { property: "og:type", content: "website" },
        { property: "og:locale", content: "th_TH" },
        { name: "twitter:card", content: "summary_large_image" },
      ],
      links: [{ rel: "canonical", href: url }, ...hreflangLinks("/tax.personal-pit", "/en/tax.personal-pit")],
    };
  },
  component: () => <SubServicePage slug="tax/personal-pit" locale="th" />,
});
